<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="$router.push('/dashboard')">Inicio</span> > Campañas Servicios</p>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo"><h5 class="mx-4 mt-5 mb-5">Campañas Servicios</h5></div>
          <div class="table-search">
            <input type="text" class="form-control" placeholder="Búsqueda rápida..."
              :value="textoBuscador" @input="teclearBuscador" />
          </div>
          <div class="descarga doble">
            <p @click="fetchData" title="Refrescar datos">
              <i class="fa fa-sync-alt" :class="{ 'fa-spin': cargando }" aria-hidden="true"></i>
            </p>
            <p @click="descargarCSV" title="Exportar CSV">
              <i class="fa fa-download" aria-hidden="true"></i>
            </p>
            <p @click="abrirCrear" title="Nueva Campaña">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </p>
            <p @click="toggleSelectorColumnas" title="Columnas visibles"
               :class="{ 'activo': selectorColumnasAbierto }">
              <i class="fas fa-columns" aria-hidden="true"></i>
            </p>
          </div>

          <!-- Selector de columnas -->
          <div v-if="selectorColumnasAbierto" class="selector-columnas-panel"
               v-click-outside="cerrarSelectorColumnas">
            <div class="selector-columnas-header">
              <span>Columnas visibles</span>
              <button class="selector-reset" @click="resetColumnas">Restablecer</button>
            </div>
            <div class="selector-columnas-grid">
              <label v-for="col in columnasConfig" :key="col.key"
                     class="selector-col-item" :class="{ disabled: col.fija }">
                <input type="checkbox" v-model="columnasVisibles[col.key]"
                       :disabled="col.fija" @change="guardarColumnasStorage" />
                <span class="selector-col-dot" :style="{ background: col.color }"></span>
                <span>{{ col.label }}</span>
              </label>
            </div>
          </div>

          <div class="filtros-admin" v-if="[1,2,5].includes(miRol)">
            <select v-model="filtroTipsterId" class="form-control form-control-sm"
                    @change="onFiltroChange">
              <option value="">Todos los tipsters</option>
              <option v-for="t in listaTipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
            </select>
            <select v-model="filtroEstado" class="form-control form-control-sm"
                    @change="onFiltroChange">
              <option value="">Todos los estados</option>
              <option value="publicada">Publicadas</option>
              <option value="borrador">Borradores</option>
              <option value="pausada">Pausadas</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-listado mt-4">
          <div class="px-4 pb-0 card-body">

            <div class="table-responsive mb-4">
              <table class="table table-flush table-listado">
                <thead class="thead-light">
                  <tr>
                    <th @click="sortTable('nombre')"
                        :class="sortColumn === 'nombre' ? sortDirection : ''">Campaña</th>
                    <th v-if="[1,2,5].includes(miRol)"
                        @click="sortTable('tipster')"
                        :class="[sortColumn === 'tipster' ? sortDirection : '', { 'd-none': !columnasVisibles.tipster }]">
                      Tipster
                    </th>
                    <th @click="sortTable('estado')"
                        :class="[sortColumn === 'estado' ? sortDirection : '', { 'd-none': !columnasVisibles.estado }]">
                      Estado
                    </th>
                    <th :class="{ 'd-none': !columnasVisibles.precio }">Precio</th>
                    <th @click="sortTable('num_ventas')"
                        :class="[sortColumn === 'num_ventas' ? sortDirection : '', { 'd-none': !columnasVisibles.num_ventas }]">
                      Núm.ventas
                    </th>
                    <th @click="sortTable('importe_ventas')"
                        :class="[sortColumn === 'importe_ventas' ? sortDirection : '', { 'd-none': !columnasVisibles.importe_ventas }]">
                      Imp.ventas
                    </th>
                    <th @click="sortTable('creado')"
                        :class="[sortColumn === 'creado' ? sortDirection : '', { 'd-none': !columnasVisibles.creado }]">
                      Creado
                    </th>
                    <th class="sin-orden">Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <tr v-for="row in filas" :key="row.id">
                    <td>
                      <span class="fw-semibold">{{ row.nombre || row.producto_nombre }}</span>
                      <div class="mt-1">
                        <span class="cs-servicio-sub">{{ row.producto_nombre }}</span>
                        <span class="tipo-badge ms-1"
                              :class="row.tipo_venta !== 'venta_unica' ? 'tipo-badge--sub' : 'tipo-badge--unico'">
                          {{ row.tipo_venta !== 'venta_unica' ? '🔄 Suscripción' : '🛒 Pago único' }}
                        </span>
                      </div>
                    </td>
                    <td v-if="[1,2,5].includes(miRol)"
                        :class="{ 'd-none': !columnasVisibles.tipster }">
                      {{ row.tipster_nombre }}
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.estado }">
                      <span class="estado-badge" :class="'estado-badge--' + row.estado">
                        {{ estadoLabel(row.estado) }}
                      </span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.precio }">
                      <span v-if="row.precio_rebajado != null" class="precio-rebajado">
                        {{ row.precio_rebajado }} {{ row.moneda }}
                      </span>
                      <span class="precio-label" :class="{ 'precio-tachado': row.precio_rebajado != null }">
                        {{ row.precio }} {{ row.moneda }}
                      </span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.num_ventas }">
                      <span class="stat-cell">{{ row.num_ventas }}</span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.importe_ventas }">
                      <span class="stat-cell">{{ row.importe_ventas.toFixed(2) }} {{ row.moneda }}</span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.creado }">{{ row.created_at }}</td>
                    <td>
                      <!-- Compradores del servicio (solo admin/admtipster) -->
                      <a v-if="[1,2].includes(miRol)" href="#" class="cursor-pointer me-3" title="Ver compradores"
                         @click.prevent="abrirCompradores(row)">
                        <i class="fas fa-users text-secondary"></i>
                      </a>
                      <!-- Editar campaña -->
                      <a href="#" class="cursor-pointer me-3" title="Editar campaña"
                         @click.prevent="abrirEditar(row)">
                        <i class="fas fa-edit text-secondary"></i>
                      </a>
                      <!-- Ir a Landing Servicios (editor de bloques) -->
                      <a href="#" class="cursor-pointer me-3" title="Editor de landing (bloques)"
                         @click.prevent="$router.push({ name: 'LandingServicios' })">
                        <i class="fas fa-rocket" style="color:#00e676"></i>
                      </a>
                      <!-- Eliminar -->
                      <a href="#" class="cursor-pointer" title="Eliminar campaña"
                         @click.prevent="confirmarBorrar(row)">
                        <i class="fas fa-trash text-secondary"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="!cargando && filas.length === 0">
                    <td :colspan="colspanTabla">No hay registros que mostrar</td>
                  </tr>
                  <tr v-if="cargando && filas.length === 0">
                    <td :colspan="colspanTabla" class="text-center py-4">
                      <i class="fa fa-spinner fa-spin"></i> Cargando…
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginación -->
            <div class="paginacion" v-if="mostradosTotal > 0">
              <p class="contador-listado">
                Mostrando {{ mostradosIni }} a {{ mostradosFin }} de {{ mostradosTotal }} registros
              </p>
              <ul class="pagination pagination-md" v-if="paginaTotal > 1">
                <li class="page-item prev-page" v-if="paginaActual > 1">
                  <a class="page-link" @click="paginaActual--; fetchData()">
                    <i class="fa fa-angle-left"></i>
                  </a>
                </li>
                <li v-for="p in rangoPaginas" :key="p" class="page-item"
                    :class="p === paginaActual ? 'active disabled' : ''">
                  <a class="page-link" @click="paginaActual = p; fetchData()">{{ p }}</a>
                </li>
                <li class="page-item next-page" v-if="paginaActual < paginaTotal">
                  <a class="page-link" @click="paginaActual++; fetchData()">
                    <i class="fa fa-angle-right"></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Crear Campaña -->
  <div v-if="modalCrear" class="cs-modal-overlay" @click.self="modalCrear=false">
    <div class="cs-modal">
      <div class="cs-modal-header">
        <span><i class="fa fa-plus-circle me-2 text-gold"></i>Nueva Campaña de Servicio</span>
        <button class="cs-modal-close" @click="modalCrear=false">✕</button>
      </div>
      <div class="cs-modal-body">
        <div class="cs-form-field">
          <label>Nombre de la campaña *</label>
          <input v-model="crear.nombre" type="text" class="form-control form-control-sm"
                 placeholder="Ej: Landing Black Friday, Campaña Verano…" maxlength="120" />
        </div>
        <div class="cs-form-field">
          <label>Tipster *</label>
          <select v-model="crear.tipster_id" class="form-control form-control-sm"
                  @change="cargarServiciosCrear()">
            <option value="">{{ cargandoTipsteresModal ? 'Cargando...' : 'Selecciona tipster' }}</option>
            <option v-for="t in tipsteresModal" :key="t.id" :value="t.id">{{ t.nombre }}</option>
          </select>
        </div>
        <div class="cs-form-field">
          <label>Servicio *</label>
          <select v-model="crear.producto_id" class="form-control form-control-sm"
                  :disabled="!crear.tipster_id || cargandoServiciosCrear">
            <option value="">{{ cargandoServiciosCrear ? 'Cargando...' : 'Selecciona servicio' }}</option>
            <option v-for="p in serviciosCrear" :key="p.id" :value="p.id">
              {{ p.nombre }} — {{ p.precio }} {{ p.moneda }}
            </option>
          </select>
        </div>
        <p v-if="errorCrear" class="cs-error mt-2">{{ errorCrear }}</p>
      </div>
      <div class="cs-modal-footer">
        <button class="cs-btn-secondary" @click="modalCrear=false">Cancelar</button>
        <button class="cs-btn-primary" :disabled="!crear.nombre || !crear.tipster_id || !crear.producto_id || creando"
                @click="crearCampana">
          <i v-if="creando" class="fa fa-spinner fa-spin me-1"></i>
          {{ creando ? 'Creando...' : 'Crear campaña' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal Editar Campaña -->
  <div v-if="modalEditar" class="cs-modal-overlay" @click.self="modalEditar=false">
    <div class="cs-modal">
      <div class="cs-modal-header">
        <span><i class="fa fa-edit me-2 text-gold"></i>Editar campaña</span>
        <button class="cs-modal-close" @click="modalEditar=false">✕</button>
      </div>
      <div class="cs-modal-body">
        <div class="cs-form-field">
          <label>Nombre de la campaña</label>
          <input v-model="editar.nombre" type="text" class="form-control form-control-sm"
                 placeholder="Ej: Landing Black Friday, Campaña Verano…" maxlength="120" />
        </div>
        <div class="cs-form-field">
          <label>Servicio</label>
          <select v-model="editar.producto_id" class="form-control form-control-sm"
                  :disabled="cargandoServiciosEditar">
            <option value="">{{ cargandoServiciosEditar ? 'Cargando...' : 'Selecciona servicio' }}</option>
            <option v-for="p in serviciosEditar" :key="p.id" :value="p.id">
              {{ p.nombre }} — {{ p.precio }} {{ p.moneda }}
            </option>
          </select>
        </div>
        <p v-if="errorEditar" class="cs-error mt-2">{{ errorEditar }}</p>
      </div>
      <div class="cs-modal-footer">
        <button class="cs-btn-secondary" @click="modalEditar=false">Cancelar</button>
        <button class="cs-btn-primary" :disabled="editando" @click="guardarEdicion">
          <i v-if="editando" class="fa fa-spinner fa-spin me-1"></i>
          {{ editando ? 'Guardando...' : 'Guardar cambios' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal Compradores -->
  <div v-if="modalCompradores" class="cs-modal-overlay" @click.self="modalCompradores=false">
    <div class="cs-modal cs-modal--lg">
      <div class="cs-modal-header">
        <span><i class="fas fa-users me-2 text-gold"></i>Compradores — {{ compradorTarget?.nombre || compradorTarget?.producto_nombre }}</span>
        <button class="cs-modal-close" @click="modalCompradores=false">✕</button>
      </div>
      <div class="cs-modal-body">
        <div v-if="cargandoCompradores" class="text-center py-3">
          <i class="fa fa-spinner fa-spin"></i> Cargando compradores…
        </div>
        <div v-else-if="compradores.length === 0" class="cs-hint text-center py-3">
          Aún no hay ventas registradas para este servicio.
        </div>
        <table v-else class="table table-flush table-listado table-sm">
          <thead class="thead-light">
            <tr>
              <th>Email / Telegram</th>
              <th>País</th>
              <th>Fecha</th>
              <th>Ref.</th>
            </tr>
          </thead>
          <tbody class="text-sm">
            <tr v-for="p in compradores" :key="p.pedido_id">
              <td>
                <span v-if="p.email !== '-'">{{ p.email }}</span>
                <span v-else-if="p.telegram_username" class="text-muted">@{{ p.telegram_username }}</span>
                <span v-else class="text-muted">—</span>
              </td>
              <td>{{ p.pais || '—' }}</td>
              <td>{{ p.fecha ? p.fecha.slice(0, 10) : '—' }}</td>
              <td class="text-muted" style="font-size:.75em">{{ p.referencia || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="cs-modal-footer">
        <button class="cs-btn-secondary" @click="modalCompradores=false">Cerrar</button>
      </div>
    </div>
  </div>

  <!-- Modal Confirmar Borrar -->
  <div v-if="modalBorrar" class="cs-modal-overlay" @click.self="modalBorrar=false">
    <div class="cs-modal cs-modal--sm">
      <div class="cs-modal-header">
        <span><i class="fa fa-exclamation-triangle me-2" style="color:#ff6b6b"></i>Eliminar campaña</span>
        <button class="cs-modal-close" @click="modalBorrar=false">✕</button>
      </div>
      <div class="cs-modal-body">
        <p>¿Confirmas que deseas eliminar la campaña <strong>{{ borrarTarget?.producto_nombre }}</strong>?</p>
        <p class="cs-hint mt-1">Esta acción no se puede deshacer. Se eliminará la landing y su contenido.</p>
      </div>
      <div class="cs-modal-footer">
        <button class="cs-btn-secondary" @click="modalBorrar=false">Cancelar</button>
        <button class="cs-btn-danger" :disabled="borrando" @click="borrar">
          <i v-if="borrando" class="fa fa-spinner fa-spin me-1"></i>
          {{ borrando ? 'Eliminando...' : 'Sí, eliminar' }}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import api from '@/services/apiClient';

const STORAGE_KEY = 'campanas_servicios_columnas_v1';

const COLUMNAS_DEFAULT = {
  tipster:        true,
  estado:         true,
  precio:         true,
  num_ventas:     true,
  importe_ventas: true,
  creado:         true,
};

const COLUMNAS_MOBILE = {
  tipster:        false,
  estado:         true,
  precio:         false,
  num_ventas:     true,
  importe_ventas: false,
  creado:         false,
};

export default {
  name: 'CampanasServicios',
  components: {},

  directives: {
    clickOutside: {
      beforeMount(el, binding) {
        el._clickOutsideHandler = (e) => { if (!el.contains(e.target)) binding.value(e); };
        setTimeout(() => document.addEventListener('click', el._clickOutsideHandler), 0);
      },
      unmounted(el) { document.removeEventListener('click', el._clickOutsideHandler); },
    },
  },

  data() {
    return {
      cargando:              false,
      filas:                 [],
      textoBuscador:         '',
      searchTimeout:         null,
      paginaActual:          1,
      paginaTotal:           0,
      mostradosIni:          0,
      mostradosFin:          0,
      mostradosTotal:        0,
      sortColumn:            'creado',
      sortDirection:         'desc',
      filtroTipsterId:       '',
      filtroEstado:          '',
      listaTipsters:         [],
      selectorColumnasAbierto: false,
      columnasVisibles:      { ...COLUMNAS_DEFAULT },
      // Modal crear
      modalCrear:            false,
      creando:               false,
      errorCrear:            null,
      crear:                 { nombre: '', tipster_id: '', producto_id: '' },
      tipsteresModal:        [],
      cargandoTipsteresModal: false,
      serviciosCrear:        [],
      cargandoServiciosCrear: false,

      // Modal editar
      modalEditar:           false,
      editarTarget:          null,
      editando:              false,
      errorEditar:           null,
      editar:                { nombre: '', producto_id: '' },
      serviciosEditar:       [],
      cargandoServiciosEditar: false,

      // Modal compradores
      modalCompradores:      false,
      compradorTarget:       null,
      compradores:           [],
      cargandoCompradores:   false,

      // Modal borrar
      modalBorrar:           false,
      borrarTarget:          null,
      borrando:              false,
    };
  },

  computed: {
    miRol()           { return Number(this.$store.getters['auth/rolEfectivo']); },
    permisos()        { return this.$store.getters['auth/permisos'] || []; },
    columnasConfig() {
      const cols = [
        { key: 'estado',         label: 'Estado',      color: '#10b981' },
        { key: 'precio',         label: 'Precio',      color: '#00e676' },
        { key: 'num_ventas',     label: 'Núm. ventas', color: '#00e676' },
        { key: 'importe_ventas', label: 'Imp. ventas', color: '#00e676' },
        { key: 'creado',         label: 'Creado',      color: '#6b7280' },
      ];
      if ([1,2,5].includes(this.miRol)) {
        cols.splice(0, 0, { key: 'tipster', label: 'Tipster', color: '#6b7280' });
      }
      return cols;
    },

    rangoPaginas() {
      const start = Math.max(this.paginaActual - 3, 1);
      const end   = Math.min(this.paginaActual + 3, this.paginaTotal);
      const pages = [];
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },

    colspanTabla() {
      let total = 6; // Campaña + Estado + Precio + Núm.ventas + Imp.ventas + Creado + Acciones
      if ([1,2,5].includes(this.miRol)) total++;
      return total;
    },
  },

  async mounted() {
    this.$store.commit('setShowFooter', true);
    this.cargarColumnasStorage();
    if ([1, 2, 5].includes(this.miRol)) await this.cargarTipsters();
    await this.fetchData();
  },

  methods: {
    teclearBuscador(event) {
      this.textoBuscador = event.target.value;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.paginaActual = 1;
        this.fetchData();
      }, 500);
    },

    onFiltroChange() {
      this.paginaActual = 1;
      this.fetchData();
    },

    sortTable(key) {
      if (this.sortColumn === key) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn    = key;
        this.sortDirection = 'asc';
      }
      this.fetchData();
    },

    async fetchData() {
      this.cargando = true;
      try {
        const params = {
          page:          this.paginaActual,
          busqueda:      this.textoBuscador || null,
          sort_column:   this.sortColumn,
          sort_dir:      this.sortDirection,
          tipster_id:    this.filtroTipsterId || null,
          estado:        this.filtroEstado    || null,
        };
        const { data } = await api.post('/api/v2/producto-landing/listar', params);
        const porPagina = 20;
        this.filas         = data.landings || [];
        this.paginaTotal   = data.paginas  || 1;
        this.paginaActual  = data.pagina   || 1;
        this.mostradosTotal = data.total   || this.filas.length;
        this.mostradosIni  = (this.paginaActual - 1) * porPagina + 1;
        this.mostradosFin  = Math.min(this.mostradosTotal, this.paginaActual * porPagina);
      } catch (e) {
        console.error(e);
      } finally {
        this.cargando = false;
      }
    },

    async cargarTipsters() {
      try {
        const { data } = await api.post('/api/v2/tipster/listar', { activos: true });
        this.listaTipsters = data.tipsters || [];
      } catch (e) { /* silencioso */ }
    },

    async descargarCSV() {
      try {
        const resp = await api.post('/api/v2/producto-landing/exportar', {
          tipster_id: this.filtroTipsterId || null,
          estado:     this.filtroEstado    || null,
        }, { responseType: 'blob' });
        const url  = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href  = url;
        link.setAttribute('download', 'campanas_servicios_' + new Date().toISOString().slice(0, 10) + '.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error('Error exportando:', e);
      }
    },

    estadoLabel(estado) {
      return { publicada: 'Publicada', borrador: 'Borrador', pausada: 'Pausada' }[estado] || estado;
    },

    toggleSelectorColumnas()  { this.selectorColumnasAbierto = !this.selectorColumnasAbierto; },
    cerrarSelectorColumnas()  { this.selectorColumnasAbierto = false; },
    guardarColumnasStorage()  {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(this.columnasVisibles)); } catch(_e) { /* silencioso */ }
    },
    cargarColumnasStorage() {
      try {
        const g = localStorage.getItem(STORAGE_KEY);
        this.columnasVisibles = g
          ? { ...COLUMNAS_DEFAULT, ...JSON.parse(g) }
          : { ...(window.innerWidth < 768 ? COLUMNAS_MOBILE : COLUMNAS_DEFAULT) };
      } catch { this.columnasVisibles = { ...COLUMNAS_DEFAULT }; }
    },
    resetColumnas() {
      this.columnasVisibles = { ...(window.innerWidth < 768 ? COLUMNAS_MOBILE : COLUMNAS_DEFAULT) };
      this.guardarColumnasStorage();
    },

    // ── CRUD ─────────────────────────────────────────────────────────
    async abrirCrear() {
      this.crear = { nombre: '', tipster_id: '', producto_id: '' };
      this.serviciosCrear = [];
      this.personalizacionesCrear = [];
      this.errorCrear = null;
      this.modalCrear = true;
      if (this.tipsteresModal.length === 0) {
        this.cargandoTipsteresModal = true;
        try {
          const { data } = await api.post('/api/v2/tipster-landing-servicio/listar');
          this.tipsteresModal = (data.tipsters || []).map(t => ({ id: t.tipster_id, nombre: t.tipster_nombre }));
        } catch (e) { /* silencioso */ } finally {
          this.cargandoTipsteresModal = false;
        }
      }
    },

    async cargarServiciosCrear() {
      if (!this.crear.tipster_id) return;
      this.crear.producto_id = '';
      this.cargandoServiciosCrear = true;
      try {
        const { data } = await api.post('/api/v2/producto-landing/servicios-tipster', { tipster_id: this.crear.tipster_id });
        this.serviciosCrear = data.productos || [];
      } catch (e) { /* silencioso */ } finally {
        this.cargandoServiciosCrear = false;
      }
    },

    async crearCampana() {
      this.errorCrear = null;
      this.creando = true;
      try {
        const { data } = await api.post('/api/v2/producto-landing/crear', {
          nombre:        this.crear.nombre.trim(),
          tipster_id:    this.crear.tipster_id,
          producto_id:   this.crear.producto_id,
          mostrar_precio: false,
          bloques:       null,
        });
        this.modalCrear = false;
        this.filas.unshift(data.landing);
        this.mostradosTotal++;
      } catch (e) {
        this.errorCrear = e?.response?.data?.message || 'Error al crear la campaña.';
      } finally {
        this.creando = false;
      }
    },

    async abrirEditar(row) {
      this.editarTarget = row;
      this.editar = { nombre: row.nombre || '', producto_id: row.producto_id || '' };
      this.serviciosEditar = [];
      this.errorEditar = null;
      this.cargandoServiciosEditar = true;
      this.modalEditar = true;
      try {
        const { data } = await api.post('/api/v2/producto-landing/servicios-tipster', { tipster_id: row.tipster_id });
        this.serviciosEditar = data.productos || [];
      } catch (e) { /* silencioso */ } finally {
        this.cargandoServiciosEditar = false;
      }
    },

    async guardarEdicion() {
      this.errorEditar = null;
      this.editando = true;
      try {
        const { data } = await api.post('/api/v2/producto-landing/guardar', {
          landing_id:  this.editarTarget.id,
          nombre:      this.editar.nombre.trim() || null,
          producto_id: this.editar.producto_id || null,
        });
        const idx = this.filas.findIndex(x => x.id === this.editarTarget.id);
        if (idx !== -1) this.filas[idx] = data.landing;
        this.modalEditar = false;
      } catch (e) {
        this.errorEditar = e?.response?.data?.message || 'Error al guardar.';
      } finally {
        this.editando = false;
      }
    },

    async abrirCompradores(row) {
      this.compradorTarget = row;
      this.compradores = [];
      this.cargandoCompradores = true;
      this.modalCompradores = true;
      try {
        const { data } = await api.post('/api/v2/tipster/productos/compradores', {
          producto_id: row.producto_id,
        });
        this.compradores = data.compradores || [];
      } catch (e) { /* silencioso */ } finally {
        this.cargandoCompradores = false;
      }
    },

    confirmarBorrar(row) {
      this.borrarTarget = row;
      this.modalBorrar = true;
    },

    async borrar() {
      this.borrando = true;
      try {
        await api.post('/api/v2/producto-landing/borrar', { landing_id: this.borrarTarget.id });
        this.filas = this.filas.filter(x => x.id !== this.borrarTarget.id);
        this.mostradosTotal--;
        this.modalBorrar = false;
      } catch (e) {
        alert(e?.response?.data?.message || 'Error al eliminar.');
      } finally {
        this.borrando = false;
      }
    },
  },
};
</script>

<style scoped>
.ficha-buscador { position: relative; }
.descarga p.activo i { color: var(--q-gold, #ffd700); }

/* Selector columnas — mismo estilo que Campanas.vue */
.selector-columnas-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 1rem;
  z-index: 999;
  background: var(--q-card, #1a1f2b);
  border: 1px solid var(--q-border, rgba(255,255,255,.1));
  border-radius: 12px;
  min-width: 260px;
  box-shadow: 0 12px 40px rgba(0,0,0,.4);
  overflow: hidden;
}
.selector-columnas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .65rem 1rem;
  font-size: .8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: var(--q-muted, #888);
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.08));
  background: var(--q-hover, rgba(255,255,255,.04));
}
.selector-reset {
  font-size: .72rem;
  color: var(--q-gold, #ffd700);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  opacity: .75;
}
.selector-reset:hover { opacity: 1; }
.selector-columnas-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  padding: .5rem;
}
.selector-col-item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: .8rem;
  cursor: pointer;
  user-select: none;
}
.selector-col-item:hover { background: var(--q-hover, rgba(255,255,255,.06)); }
.selector-col-item input[type="checkbox"] { margin: 0; cursor: pointer; accent-color: var(--q-gold, #ffd700); }
.selector-col-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }

.filtros-admin {
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: 0 1rem 1rem;
  flex-wrap: wrap;
}
.filtros-admin select { min-width: 0; width: 100%; max-width: 220px; font-size: .82rem; }
@media (max-width: 767px) {
  .filtros-admin { padding: 0 .75rem .5rem; }
  .filtros-admin select { max-width: 100%; flex: 1 1 140px; }
}

.table-flush td { vertical-align: middle; }

.tipo-badge { display: inline-block; font-size: .7em; padding: 2px 7px; border-radius: 10px; }
.tipo-badge--sub   { background: rgba(59,130,246,.15);  color: #3b82f6; }
.tipo-badge--unico { background: rgba(16,185,129,.15);  color: #10b981; }

.precio-label    { font-size: .82em; }
.precio-tachado  { text-decoration: line-through; color: var(--q-muted, #888); margin-left: .3rem; }
.precio-rebajado { font-size: .82em; font-weight: 700; color: #00e676; }

.estado-badge { font-size: .72em; padding: 3px 8px; border-radius: 10px; }
.estado-badge--publicada { background: rgba(0,200,68,.15);   color: #00c844; }
.estado-badge--borrador  { background: rgba(255,255,255,.08); color: #aaa;    }
.estado-badge--pausada   { background: rgba(255,165,0,.15);  color: #ffa500; }


.stat-cell { display: inline-flex; align-items: center; font-variant-numeric: tabular-nums; }
.cs-servicio-sub { font-size: .72em; opacity: .55; }

/* Modales */
.cs-modal-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,.65); z-index: 9999;
  display: flex; align-items: center; justify-content: center;
}
.cs-modal {
  background: var(--q-card, #1a1f2b);
  border: 1px solid var(--q-border, rgba(255,255,255,.1));
  border-radius: 14px; width: 100%; max-width: 440px; max-height: 90vh;
  overflow-y: auto; box-shadow: 0 20px 60px rgba(0,0,0,.5);
}
.cs-modal--sm { max-width: 380px; }
.cs-modal--lg { max-width: 680px; }
.cs-modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 1rem 1.25rem; border-bottom: 1px solid var(--q-border, rgba(255,255,255,.08));
  font-weight: 600; font-size: .9rem;
}
.cs-modal-close { background: none; border: none; cursor: pointer; font-size: 1rem; opacity: .6; color: inherit; }
.cs-modal-close:hover { opacity: 1; }
.cs-modal-body { padding: 1.25rem; }
.cs-modal-footer {
  display: flex; justify-content: flex-end; gap: .75rem;
  padding: 1rem 1.25rem; border-top: 1px solid var(--q-border, rgba(255,255,255,.08));
}
.cs-form-field { margin-bottom: .85rem; }
.cs-form-field label { display: block; font-size: .78rem; font-weight: 600; margin-bottom: 4px; opacity: .8; }
.cs-hint { font-size: .72rem; opacity: .55; }
.cs-error { font-size: .78rem; color: #ff6b6b; }
.cs-btn-primary {
  font-size: .8rem; font-weight: 700; padding: 6px 16px; border-radius: 8px;
  background: var(--q-gold, #ffd700); color: #000; border: none; cursor: pointer;
}
.cs-btn-primary:disabled { opacity: .45; cursor: not-allowed; }
.cs-btn-secondary {
  font-size: .8rem; padding: 6px 14px; border-radius: 8px;
  background: rgba(255,255,255,.07); color: inherit; border: 1px solid rgba(255,255,255,.12); cursor: pointer;
}
.cs-btn-danger {
  font-size: .8rem; font-weight: 700; padding: 6px 16px; border-radius: 8px;
  background: rgba(255,107,107,.2); color: #ff6b6b; border: 1px solid rgba(255,107,107,.3); cursor: pointer;
}
.cs-btn-danger:disabled { opacity: .45; cursor: not-allowed; }
.cs-btn-danger:hover:not(:disabled) { background: rgba(255,107,107,.35); }
</style>
